/**
 * `/settings/enrichment` — this month's credit use, one ledger per vendor.
 *
 * No admin gate, deliberately. The counts are this workspace's own spend, the
 * server scopes the answer to the caller's org, and the person who will hit a
 * cap mid-run is whoever is looking people up — not whoever happens to
 * administer the deployment. Hiding it behind a role would put the warning in
 * front of the one person who does not need it.
 *
 * Thin on purpose, like `/settings/users`: the panel is a component so it can be
 * mounted in a test without a router, and this file stays a route declaration.
 */

import { createFileRoute } from '@tanstack/react-router';
import { RouteErrorPanel } from '../../../components/route-error-boundary.tsx';
import { EnrichmentBudgetPanel } from '../../../components/settings/enrichment-budget.tsx';

export const Route = createFileRoute('/_authed/settings/enrichment')({
  component: EnrichmentBudgetPanel,
  errorComponent: RouteErrorPanel,
});
